export default __webpack_public_path__ + "static/media/herone.65948f10.png";